import React, {Fragment} from 'react';
import Alert from './Alert';
import styled from 'styled-components';
import {AddAlert, Notifications} from "@material-ui/icons";
import { Button, Popover, withStyles } from "@material-ui/core";
import PrimaryBadge from 'components/Global/Badge/PrimaryBadge';

const ArrowUpDiv = styled.div`
  & {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;    
    border-bottom: 10px solid red;
  }
`
const PopoverContent = styled.div`
  display:flex;
  flex-flow:column;
  align-items:flex-end;
`
const Notification = styled.div`
  padding:10px;
`
const LargeFont = styled.div`
  font-size: 17px;
  font-weight:bold;
`
const MidFont = styled.div`
  font-size: 17px;
`
const SmallFont = styled.div`
  font-size:17px;
`
const styles = theme => ({

})

class AlertContainer extends React.Component {
  state={
    isAlertPopoverOpen: false,
    anchorEl: null
  }

  openFakeAlert = (event) => {    
    this.setState({
      anchorEl: event.currentTarget,
      isAlertPopoverOpen:true
    })
  }
  closeFakeAlert = () => {
    this.setState({
      isAlertPopoverOpen:false
    })
  }
    renderAlertModal = () => {
    const {isModalOpen} = this.props;
    let alert = {
      alertFor: '',
      index: 1,
      sendTo: [],
      test: '',
      trigger: '',
      message: ''
    }
    let indexOptions = [
      { id: 1,
        name: '10 Yr Treasury'
      },
      { id: 2,
        name: 'Cap Cost'
      },
      { id: 3,
        name: 'Prepayment Penalty'
      },
      { id: 4,
        name: 'DSCR'
      },
      { id: 4,
        name: 'LTV'
      },
    ]
    let testOptions = [
      {
        id: 1,
        name: '>='
      },
      {
        id: 2,
        name: '<='
      }
    ]
    let sendToOptions =[
      {
        id: 1,
        name: 'Caleb Lewallen'
      },
      {
        id: 2,
        name: 'JP Conklin'
      },
      {
        id: 3,
        name: 'Rob Hudson'
      },
      {
        id: 4,
        name: 'Sarah Nelson'
      }
    ]
    return (
      <Alert 
        alert={alert}
        isOpen={isModalOpen} 
        indexOptions={indexOptions}
        testOptions={testOptions}
        sendToOptions={sendToOptions}
        onClose={this.props.closeModal}/>
    )
  }
  render() {
    const {
      anchorEl,
      isAlertPopoverOpen,
    } = this.state;

    const { 
      isModalOpen,
      showAlertIcon,
      showReminderIcon,
      openModal,
    } = this.props;
    
    return(
      <Fragment>
        { showAlertIcon &&
        <Button id="mainNavAddAlert" className="button_50x50" onClick={openModal}>
          <AddAlert />
        </Button>
         }
        <div>
          { showReminderIcon && 
          <Button className="button_50x50" id="mainNavViewAlerts">
            <PrimaryBadge badgeContent={1} onClick={this.openFakeAlert}>
              <Notifications/>
            </PrimaryBadge>
          </Button>
          }
          <Popover             
            open={isAlertPopoverOpen} 
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            onClose={this.closeFakeAlert}>               
            <Notification id="notification">
              <LargeFont>The Oxford - DSCR &lt; 1.25</LargeFont>            
              <SmallFont>DSCR = 1.2467</SmallFont>
              <MidFont>DSCR has fallen below threshold, Cash Management provisions triggered.</MidFont>
            </Notification>
          </Popover>
        </div>
        {isModalOpen && this.renderAlertModal()}
      </Fragment>
    )
  }
}

export default withStyles(styles)(AlertContainer);
